import request from "root/js/request";

export const getWBDynamicProductsSummary = async ({
  on_site_date__gte,
  on_site_date__lte,
  period,
  sales__gte,
  sales__lte,
  sales_proceeds__gte,
  sales_proceeds__lte,
  date_from,
  date_to,
  brand_id__in,
  category_id__in,
  seller_id__in,
  product_id__in,
  orders__gte,
  orders__lte,
  proceeds__gte,
  proceeds__lte,
  quantity__gte,
  quantity__lte,
  returns__gte,
  returns__lte,
  lost_proceeds__gte,
  lost_proceeds__lte,
  incomes__gte,
  incomes__lte,
  ransom__gte,
  ransom__lte,
  sales_percent__gte,
  sales_percent__lte,
  price__gte,
  price__lte,
  old_price__gte,
  old_price__lte,
  discount__gte,
  discount__lte,
  basic_discount__gte,
  basic_discount__lte,
  promo_discount__gte,
  promo_discount__lte,
  orders_failed__gte,
  orders_failed__lte,
  proceeds_failed__gte,
  proceeds_failed__lte,
  vendor_codes__gte,
  vendor_codes__lte,
  position__gte,
  position__lte,
  avg_proceeds__gte,
  avg_proceeds__lte,
  sellers__gte,
  sellers__lte,
  reviews__gte,
  dynamic_sales_percent__lte,
  dynamic_sales_percent__gte,
  reviews__lte,
  lost_proceeds_share__gte,
  lost_proceeds_share__lte,
  dynamic_proceeds_percent__gte,
  dynamic_proceeds_percent__lte,
  dynamic_vendor_codes_percent__gte,
  dynamic_vendor_codes_percent__lte,
  dynamic_orders_percent__gte,
  dynamic_orders_percent__lte,
  dynamic_price_percent__gte,
  dynamic_price_percent__lte,
  dynamic_avg_proceeds_percent__gte,
  dynamic_avg_proceeds_percent__lte,
  dynamic_lost_proceeds_percent__gte,
  dynamic_lost_proceeds_percent__lte,
  dynamic_quantity_percent__gte,
  dynamic_quantity_percent__lte,
  sellers_with_orders__gte,
  sellers_with_orders__lte,
  products_with_orders__gte,
  products_with_orders__lte,
  avg_percent_articles_with_orders__gte,
  avg_percent_articles_with_orders__lte,
  avg_proceeds_per_article__gte,
  avg_proceeds_per_article__lte,
  avg_proceeds_per_article_with_orders__gte,
  avg_proceeds_per_article_with_orders__lte,
  avg_orders_per_article__gte,
  avg_orders_per_article__lte,
  avg_orders_per_article_with_orders__gte,
  avg_orders_per_article_with_orders__lte,
  limit,
  offset,
  ordering,
  month_width,
  weighted_price__gte,
  weighted_price__lte,
}) => {
  const response = await request({
    url: `/wb_dynamic/products_summary/`,
    method: "get",
    params: {
      period,
      on_site_date__gte,
      on_site_date__lte,
      date_from,
      date_to,
      sales__gte,
      sales__lte,
      sales_proceeds__gte,
      sales_proceeds__lte,
      brand_id__in,
      category_id__in,
      seller_id__in,
      product_id__in,
      orders__gte,
      orders__lte,
      proceeds__gte,
      proceeds__lte,
      quantity__gte,
      quantity__lte,
      dynamic_sales_percent__lte,
      dynamic_sales_percent__gte,
      returns__gte,
      returns__lte,
      lost_proceeds__gte,
      lost_proceeds__lte,
      incomes__gte,
      incomes__lte,
      ransom__gte,
      ransom__lte,
      sales_percent__gte,
      sales_percent__lte,
      price__gte,
      price__lte,
      old_price__gte,
      old_price__lte,
      discount__gte,
      discount__lte,
      basic_discount__gte,
      basic_discount__lte,
      promo_discount__gte,
      promo_discount__lte,
      orders_failed__gte,
      orders_failed__lte,
      proceeds_failed__gte,
      proceeds_failed__lte,
      vendor_codes__gte,
      vendor_codes__lte,
      position__gte,
      position__lte,
      avg_proceeds__gte,
      avg_proceeds__lte,
      sellers__gte,
      sellers__lte,
      reviews__gte,
      reviews__lte,
      lost_proceeds_share__gte,
      lost_proceeds_share__lte,
      dynamic_proceeds_percent__gte,
      dynamic_proceeds_percent__lte,
      dynamic_vendor_codes_percent__gte,
      dynamic_vendor_codes_percent__lte,
      dynamic_orders_percent__gte,
      dynamic_orders_percent__lte,
      dynamic_price_percent__gte,
      dynamic_price_percent__lte,
      dynamic_avg_proceeds_percent__gte,
      dynamic_avg_proceeds_percent__lte,
      dynamic_lost_proceeds_percent__gte,
      dynamic_lost_proceeds_percent__lte,
      dynamic_quantity_percent__gte,
      dynamic_quantity_percent__lte,
      sellers_with_orders__gte,
      sellers_with_orders__lte,
      products_with_orders__gte,
      products_with_orders__lte,
      avg_percent_articles_with_orders__gte,
      avg_percent_articles_with_orders__lte,
      avg_proceeds_per_article__gte,
      avg_proceeds_per_article__lte,
      avg_proceeds_per_article_with_orders__gte,
      avg_proceeds_per_article_with_orders__lte,
      avg_orders_per_article__gte,
      avg_orders_per_article__lte,
      avg_orders_per_article_with_orders__gte,
      avg_orders_per_article_with_orders__lte,
      limit,
      offset,
      ordering,
      month_width: month_width || undefined,
      weighted_price__gte,
      weighted_price__lte,
    },
  });
  return response.data;
};
